var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUploadLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#B7B7C2",
  d: "M19.3 4.594H4.7c-.4 0-.7.3-.7.7v14.7c0 .3.3.6.7.6h14.7c.4 0 .7-.3.7-.7v-14.6c-.1-.4-.4-.7-.8-.7m-10.6 13.6H6.4v-7.6h2.4v7.6zm-1.1-8.6c-.8 0-1.4-.7-1.4-1.4 0-.8.6-1.4 1.4-1.4s1.4.6 1.4 1.4c-.1.7-.7 1.4-1.4 1.4m10 8.6h-2.4v-3.7c0-.9 0-2-1.2-2s-1.4 1-1.4 2v3.8h-2.4v-7.7h2.3v1c.3-.6 1.1-1.2 2.2-1.2 2.4 0 2.8 1.6 2.8 3.6v4.2z"
})));
export default SvgUploadLinkedin;